import apiClient from "@/utils/axios";
import { Order } from "@/interfaces/order.interface";
import { ApiResponse } from "@/interfaces/api-response";
import { FilterQuery } from "@/stores/order-filter.store";

const getMany = async (params: {
  page: number;
  size: number;
  search?: string;
  filters?: Partial<FilterQuery>;
}) => {
  const { page, size, search, filters } = params;
  const response = await apiClient.get<ApiResponse<Order[]>>(`/orders`, {
    params: {
      page,
      size,
      search,
      ...filters,
    },
  });
  return response.data;
};

const getOne = async (id: string) => {
  const response = await apiClient.get<ApiResponse<Order>>(`/orders/${id}`);
  return response.data;
};

const updateOne = async (id: string, data: Partial<Order>) => {
  const response = await apiClient.put<Order>(`/orders/${id}`, data);
  return response.data;
};

const orderApi = {
  getMany,
  getOne,
  updateOne,
};

export default orderApi;
